// extracted by mini-css-extract-plugin
module.exports = {"full":"idt-prefabpickergriditem_full__3erkt"};